import React from 'react';
import { Phone, ArrowRight, MapPin, ShieldCheck, Clock, Sparkles, Star } from 'lucide-react';
import { company } from '../data/content';

const HERO_BG = '/assets/hero-bg.jpg';

export default function Hero() {
  return (
    <section id="start" data-testid="hero-section" className="relative pt-40 pb-16 lg:pt-56 md:pb-24 overflow-hidden bg-[#0B1E44]">
      {/* Background image */}
      <div className="absolute inset-0" aria-hidden>
        <img src={HERO_BG} alt="" className="w-full h-full object-cover object-center" data-testid="hero-bg-image" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050E24]/95 via-[#0B1E44]/70 to-[#0B1E44]/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050E24]/80 via-transparent to-[#0B1E44]/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl fade-in-up hero-text-shadow">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-[#E0A72C]/40 backdrop-blur-sm rounded-full pl-1 pr-4 py-1 text-white">
            <span className="bg-[#E0A72C] text-[#0B1E44] px-2.5 py-1 rounded-full text-[11px] font-extrabold uppercase tracking-wider">Neu</span>
            <div className="flex items-center gap-1 text-[13px]">
              <div className="flex">{[1,2,3,4,5].map((s)=><Star key={s} className="w-3.5 h-3.5 fill-[#FBBC05] text-[#FBBC05]" />)}</div>
              <span className="ml-1 font-semibold">4,9 Google-Bewertung</span>
            </div>
          </div>

          <h1 className="mt-6 text-white font-extrabold leading-[1.02] text-4xl sm:text-5xl md:text-6xl lg:text-[72px] tracking-tight">
            Wir bringen Ihr Zuhause <span className="gold-text">zum Glänzen.</span>
          </h1>

          <p className="mt-6 text-white/95 text-lg md:text-xl max-w-2xl leading-relaxed">
            Professionelle Reinigung, Sanierung und Pflege für Ihre Immobilie – zuverlässig, gründlich und planbar für Gewerbe, Hausverwaltungen und Privatkunden in ganz Deutschland.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="#kontakt" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-md text-[15px]">
              Kostenlose Beratung sichern <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#leistungen" className="btn-ghost-light inline-flex items-center gap-2 px-6 py-3.5 rounded-md text-[15px] font-medium">
              Leistungen ansehen
            </a>
          </div>

          <a href={`tel:${company.phoneRaw}`} className="mt-6 inline-flex items-center gap-4 rounded-2xl bg-white/10 hover:bg-white/15 border border-[#E0A72C]/50 backdrop-blur-md pl-3 pr-6 py-3 transition-colors group" data-testid="hero-phone">
            <span className="w-14 h-14 rounded-xl bg-[#E0A72C] text-[#0B1E44] flex items-center justify-center shadow-[0_8px_20px_rgba(224,167,44,0.45)] group-hover:scale-105 transition-transform">
              <Phone className="w-6 h-6" />
            </span>
            <span className="leading-tight">
              <span className="block text-[#E8B547] text-[11px] uppercase tracking-[0.2em] font-bold">Jetzt direkt anrufen</span>
              <span className="block text-white font-extrabold text-2xl sm:text-3xl tracking-wide">{company.phone}</span>
              <span className="block text-white/70 text-xs mt-0.5">Mo–Fr 09–18 Uhr · Sa 09–16 Uhr</span>
            </span>
          </a>

          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-3 max-w-2xl">
            {[
              { i: MapPin, t: 'Deutschlandweit' },
              { i: ShieldCheck, t: 'Gewerbe & Privat' },
              { i: Clock, t: 'Einmalig oder regelmäßig' },
              { i: Sparkles, t: 'Faire Einschätzung' },
            ].map((f, idx) => (
              <div key={idx} className="flex items-center gap-2 text-white text-sm bg-[#0B1E44]/60 border border-white/20 rounded-lg px-3 py-2.5 backdrop-blur-md">
                <f.i className="w-4 h-4 text-[#E0A72C]" /> {f.t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
